// In-memory and sessionStorage cache for dynamic SAS token and URL
let cachedSasUrl = "";
let cachedSasToken = "";
let fetchPromise = null;

const STORAGE_KEY_URL = "__AZURE_SAS_URL";
const STORAGE_KEY_TOKEN = "__AZURE_SAS_TOKEN";
const STORAGE_KEY_EXP = "__AZURE_SAS_EXP";

// Restore synchronously from sessionStorage if present and valid
if (typeof window !== "undefined") {
  try {
    const storedExp = sessionStorage.getItem(STORAGE_KEY_EXP);
    const storedUrl = sessionStorage.getItem(STORAGE_KEY_URL);
    const storedToken = sessionStorage.getItem(STORAGE_KEY_TOKEN);
    if (storedUrl && storedExp && new Date(storedExp) > new Date()) {
      cachedSasUrl = storedUrl;
      cachedSasToken = storedToken || "";
    }
  } catch (e) {}
}

export const setDynamicSas = (token, url, expiresAt) => {
  if (token) cachedSasToken = token;
  if (url) cachedSasUrl = url;
  if (typeof window !== "undefined") {
    if (token) window.__AZURE_SAS_TOKEN = token;
    if (url) window.__AZURE_SAS_URL = url;
    
    try {
      if (url) sessionStorage.setItem(STORAGE_KEY_URL, url);
      if (token) sessionStorage.setItem(STORAGE_KEY_TOKEN, token);
      if (expiresAt) {
        sessionStorage.setItem(STORAGE_KEY_EXP, expiresAt);
      } else {
        // Default 15 minutes expiry for session storage
        sessionStorage.setItem(
          STORAGE_KEY_EXP,
          new Date(Date.now() + 15 * 60 * 1000).toISOString()
        );
      }
    } catch (e) {}
  }
};

export const fetchSasFromApi = async () => {
  if (cachedSasUrl && cachedSasUrl.includes("?sv=")) return cachedSasUrl;
  if (fetchPromise) return fetchPromise;

  if (typeof window === "undefined") {
    return cachedSasUrl;
  }

  fetchPromise = fetch("/api/sas/admin?minutes=15")
    .then((res) => {
      if (!res.ok) throw new Error("Failed to fetch admin SAS");
      return res.json();
    })
    .then((data) => {
      if (data.sasUrl) {
        setDynamicSas(data.sasToken, data.sasUrl, data.expiresAt);
      }
      fetchPromise = null;
      return cachedSasUrl;
    })
    .catch((err) => {
      console.warn("Could not fetch dynamic SAS URL:", err);
      fetchPromise = null;
      return cachedSasUrl;
    });

  return fetchPromise;
};

// Initiate dynamic fetch immediately in browser
if (typeof window !== "undefined") {
  if (!cachedSasUrl || !cachedSasUrl.includes("?sv=")) {
    fetchSasFromApi();
  }
}

const accountName =
  process.env.NEXT_PUBLIC_ACCOUNT_NAME || "bnlwestgunileveraf01092";

const endpoints = {
  AccountName: accountName,
  redirectUriLogin:
    process.env.NEXT_PUBLIC_REDIRECT_URI_LOGIN || "http://localhost:3000",
  baseUrl:
    process.env.NEXT_PUBLIC_BASE_URL || "http://localhost:4540/node/api",
  createContact: "contact/createContact",
  globalSearch: "elastic/globalSearch",
  drupalIp: process.env.NEXT_PUBLIC_DRUPAL_IP || "http://localhost/",
  drupalIpContent:
    process.env.NEXT_PUBLIC_DRUPAL_IP_CONTENT || "http://localhost/drupal",
  fetchBlobUrl:
    process.env.NEXT_PUBLIC_FETCH_BLOB_URL ||
    `https://${accountName}.blob.core.windows.net/botstorevideo`,
  clientId:
    process.env.NEXT_PUBLIC_CLIENT_ID || "78ded294-9fe9-47ae-8546-48b32a078f16",
  authority:
    process.env.NEXT_PUBLIC_AUTHORITY ||
    "https://login.microsoftonline.com/f66fae02-5d36-495b-bfe0-78a6ff9f8e6e",
  sumbitAnIdea: "ideas/submitIdea",
  demoRequest: "/demo/createDemoRequest",
  createBO: "/user/createBO",

  // Dynamic getter for blobSasUrlNew so all 26 components receive the secure token automatically
  get blobSasUrlNew() {
    if (cachedSasUrl) return cachedSasUrl;
    if (typeof window !== "undefined" && window.__AZURE_SAS_URL) {
      return window.__AZURE_SAS_URL;
    }
    // Safe placeholder URL so `new BlobServiceClient(...)` does not crash during initial render
    return `https://${accountName}.blob.core.windows.net/?`;
  },
  set blobSasUrlNew(val) {
    setDynamicSas(cachedSasToken, val);
  },

  // Dynamic getter for sasToken
  get sasToken() {
    if (cachedSasToken) return cachedSasToken;
    if (typeof window !== "undefined" && window.__AZURE_SAS_TOKEN) {
      return window.__AZURE_SAS_TOKEN;
    }
    return "";
  },
  set sasToken(val) {
    setDynamicSas(val, cachedSasUrl);
  },
};

export default endpoints;

